module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarReporteBoletas) ? _c('div', {
    key: "reporte_boletas",
    staticClass: "box position-relative"
  }, [_c('lista-boletas', {
    on: {
      "close": function($event) {
        _vm.mostrarReporteBoletas = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e45c6ec6","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Boletas_Reporte.vue
// module id = 965
// module chunks = 0